/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


import React from "react";
import ReactDOM from "react-dom";
import { LoadingAnimation } from "../../React/Components/LoadingAnimation";

export class FetchHTML extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            text: <LoadingAnimation className="width-100"/>,
        };
    }
    
    componentDidMount(){
        if(!this.props.url){
            this.setState({
                text: false,
            });
            
            return;
        }
    
        fetch(this.props.url)
            .then(response => response.text())
            .then(data => { 
                this.setState({text: data});
            });
    }
    
    render(){
        if(!this.state.text) return(null); 
    
        return(
            <div 
                className={(this.props.className ? this.props.className : '')} 
                dangerouslySetInnerHTML={{__html: this.state.text}} 
                style={(this.props.style ? this.props.style : {})} 
            />
        );
    }
}

